<template>
    <div>
        <div class="card">
            <div class="card-body">

                <div>
                    <pulse-loader :loading="!records" :color="color" style="text-align: center"/>
                </div>

                <table class="table table-hover" v-if="records">
                    <thead>
                    <tr>
                        <th><input type="checkbox" @change="selectAll"></th>
                        <th name="name" class="sortingClass.name[filterSort]">Имя</th>
                        <th>ЕГК</th>
                        <th>Препараты</th>
                        <th @click="changeSort" name="offers" :class="sortingClass.offers[filterSort]">aptekamos</th>
                        <th>Link</th>
                        <th v-if="tableType == 'grouped'">Search слова</th>
                        <th v-if="tableType == 'grouped'">Запросы</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(record, index) in records" :key="index">
                        <td><input type="checkbox" class="selectedDrug" :name="record.id"></td>
                        <td>{{record.ros_name}}</td>
                        <td>
                            <p v-for="(code, index) in record.codes">
                                {{code.egk_id}}
                            </p>
                        </td>
                        <td>
                            <p v-for="(code, index) in record.codes" v-html="printCode(code.info.DRUG_NAME)">
                            </p>
                        </td>
                        <td>
                            <div v-if="record.parsed_info">
                                <div>
                                    <template v-if="record.parsed_info.offers">
                                        <p>Предложений: <strong>{{record.parsed_info.offers}}</strong></p>
                                        <p v-if="record.parsed_info.min_price">Min цена:
                                            <strong>{{record.parsed_info.min_price}}</strong></p>
                                        <p v-if="record.parsed_info.max_price">Max цена:
                                            <strong>{{record.parsed_info.max_price}}</strong></p>
                                        <div>
                                            <time-ago refresh :long="long" :tooltip="tooltip"
                                                      :datetime="record.parsed_info.updated_at"></time-ago>
                                            <i @click="updateStatistic(record.id, 'offers')"
                                               :id="`updating_${record.id}`"
                                               class="icon-fa icon-fa-refresh pointer green m-l-10"></i>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <p>Предложений не найдено <i @click="updateStatistic(record.id)"
                                                                     :id="`updating_${record.id}`"
                                                                     class="icon-fa icon-fa-refresh pointer green m-l-10"></i>
                                        </p>
                                    </template>
                                </div>
                            </div>
                            <div v-else>
                                <div>
                                    <p>Продукт не был найден <i @click="updateStatistic(record.id)"
                                                                :id="`updating_${record.id}`"
                                                                class="icon-fa icon-fa-refresh pointer green m-l-10"></i>
                                    </p>
                                </div>
                            </div>
                        </td>
                        <td>
                            <a :href="`https://aptekamos.ru/tovary/poisk?q=${record.ros_name}&inr=0`"
                               target="_blank"><i class="icon-fa icon-fa-link"></i></a>
                        </td>
                        <td v-if="tableType == 'grouped'">
                            <form action="" @submit="updateWords">
                                <input type="hidden" name="id" :value="record.id">
                                <div class="input-group">
                                    <textarea @change="showBtn(record.id)" class='form-control' required name="words"
                                              rows="3">{{printSearchWords(record.search_words)}}</textarea>
                                    <div class="input-group-prepend">
                                        <button type="submit" :id="`wordBtn_${record.id}`"
                                                class="btn btn-success hidden">
                                            Сохранить
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </td>
                        <td v-if="tableType == 'grouped'">
                            <div v-html="printSearchWordsStatistic(record.search_words)"></div>
                            <div v-if="record.search_words">
                                <div v-if="record.search_words && record.search_words[0] && (record.search_words[0].in_updating == 0 || record.search_words[0].in_updating == 2)">
                                    <time-ago
                                            refresh :long="long" :tooltip="tooltip"
                                            :datetime="record.search_words[0].updated_at"></time-ago>
                                    <i @click="updateStatistic(record.id, 'wordstat')" :id="`updating_word_${record.id}`"
                                       class="icon-fa icon-fa-refresh pointer green m-l-10"></i>
                                </div>
                                <div v-else>
                                    Обновление
                                </div>
                            </div>
                            <div v-else>
                                <span>Добавьте слова</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import api from '@/api'
    import TimeAgo from 'vue2-timeago'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'


    export default {
        components: {
            TimeAgo,
            PulseLoader
        },
        props: [
            'tableRecords', 'tableType', 'filter', 'updateSort'
        ],
        data() {
            return {
                long: true,
                sortingClass: {
                    offers: {
                        0: 'offers table-component__th table-component__th--sort-asc',
                        1: 'offers table-component__th table-component__th--sort-desc',
                    },
                    name: {
                        0: 'w-27 table-component__th table-component__th--sort-asc',
                        1: 'w-27 table-component__th table-component__th--sort-desc',
                    }
                },
                filterSort: 0,
                filterType: 'name',
                tooltip: true,
                color: '#5BBFDE',
                Toast: this.$swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }),
            }
        },
        computed: {
            records() {
                try {
                    this.filterSort = this.filter.sorting ? 1 : 0;
                } catch (e) {
                    this.filterSort = 1;
                }
                return this.tableRecords;
            }
        },
        methods: {
            changeSort(e) {
                // let t_class = '';
                let type = 'name'
                // console.log(e.target.getAttribute('name'));
                if (e.target.getAttribute('name') == 'offers') {
                    type = 'offers';
                }
                this.filterType = type;
                this.filterSort = this.filterSort ? 0 : 1;
                // if (this.filterSort){
                //     e.target.className = t_class + ' table-component__th table-component__th--sort-asc'
                // }else{
                //     e.target.className = t_class + ' table-component__th table-component__th--sort-desc'
                // }
                this.updateSort(this.filterSort, type);
            },
            selectAll(e) {
                let elements = document.querySelectorAll('.selectedDrug');
                elements.forEach((el) => {
                    el.checked = e.target.checked;
                });
            },
            clearCheckboxes() {
                let elements = document.querySelectorAll('input[type="checkbox"]');
                elements.forEach((el) => {
                    el.checked = false;
                });
            },
            printSearchWords(words) {
                let text = "";
                if (!words) return text;
                words.forEach((v, i) => {
                    if (v.is_visible) {
                        if (i > 0) text += ", ";
                        text += v.word;
                    }
                });
                return text;
            },
            printSearchWordsStatistic(words) {
                let html = '';
                if (!words) return html;
                words.forEach((v, i) => {
                    html += '<p>' + v.word + ': <strong>' + (v.requests === null ? 'не обновлено' : v.requests) + '</strong></p>';
                });
                return html;
            },
            printCode(name) {
                let p_name = name;
                let short = false;
                if (name.length > 20) {
                    p_name = name.substr(0, 20) + '...';
                    short = true;
                }
                return '<span title="' + name + '" class="pointer">' + p_name + ' ' + (short ? '<i class="icon-fa icon-fa-info-circle"></i>' : '') + '</span>';
            },
            updateWords: async function (e) {
                e.preventDefault();
                let {data} = await api.store('/egk/updateSearchWords', {
                    id: e.target.id.value,
                    words: e.target.words.value,
                })
                if (data.success) {
                    this.Toast.fire({
                        type: 'success',
                        title: 'Сохранено'
                    })
                    document.querySelector('#wordBtn_' + e.target.id.value).classList.add('hidden');
                } else {
                    this.Toast.fire({
                        type: 'warning',
                        title: 'Ошибка'
                    })
                }
            },
            showBtn(id) {
                document.querySelector('#wordBtn_' + id).classList.remove('hidden');
            },
            async updateStatistic(id, type = 'offers') {
                if (type == 'offers')
                    document.querySelector('#updating_' + id).classList.add('rotating');
                else
                    document.querySelector('#updating_word_' + id).classList.add('rotating');

                let {data} = await api.store('/egk/updateStatistic', {
                    id: id,
                    type: type
                });
                if (data.success) {
                    this.records.map((r) => {
                        if (r.id == id) {
                            if (!r.parsed_info) r.parsed_info = {};
                            r.parsed_info.updated_at = data.parsed_info.updated_at;
                            r.parsed_info.offers = data.parsed_info.offers;
                            r.parsed_info.min_price = data.parsed_info.min_price;
                            r.parsed_info.max_price = data.parsed_info.max_price;
                        }
                    });
                    // this.records = {...this.records};
                    this.Toast.fire({
                        type: 'success',
                        title: type == 'offers' ? 'Обновлено' : 'Отправлено'
                    })
                } else {
                    this.Toast.fire({
                        type: 'warning',
                        title: 'Ошибка ' + data.message
                    });
                }
                let icon = document.querySelector('#updating_' + id);
                if (icon)
                    icon.classList.remove('rotating');
                let icon2 = document.querySelector('#updating_word_' + id);
                if (icon2)
                    icon2.classList.remove('rotating');
            }
        }
    }
</script>

<style scoped>
    .m-b-0 {
        margin-bottom: 0;
    }

    .green {
        color: lightgreen;
    }

    .m-l-10 {
        margin-left: 10px;
    }

    .w-27 {
        width: 27%;
    }

    table .flex {
        display: flex;
        justify-content: space-between;
    }

    table .flex .refresh_div {
        padding: 0 10px;
        align-self: center;
        position: relative;
    }

    table .hidden {
        display: none;
    }

    td p {
        margin-bottom: 2px;
    }

    th.offers {
        min-width: 180px;
    }

    table td {
        padding: 3px;
    }

    table textarea {
        padding: 2px 10px;
    }
</style>
<style>
    .pointer {
        cursor: pointer;
    }

    td p {
        margin-bottom: 2px;
    }

    i.rotating {
        -webkit-animation: spin 4s linear infinite;
        -moz-animation: spin 4s linear infinite;
        animation: spin 4s linear infinite;
    }

    @-moz-keyframes spin {
        100% {
            -moz-transform: rotate(360deg);
        }
    }

    @-webkit-keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
</style>
